import axios from 'axios'
import { IOrderResponse } from './interfaces/tracker.interfaces'

const client = axios.create({
  baseURL: process.env.REACT_APP_TRACKER_API,
  timeout: 61000,
})

/*
|--------------------------------------------------------------------------
| Handlers
|--------------------------------------------------------------------------
*/
export const urlCarriers = (id: string = null): string => {
  return id ? `/carriers/${id}` : '/carriers'
}

/**
 * To be used with SWR
 * @param url
 * @param params
 */
export const trackerAPIFetcher = (url: string, params = undefined) => {
  return client.get(url, params).then(res => res.data)
}

export const fetchPackageInformation = (
  carrier: string,
  id: string,
  params: { [index: string]: string } = {},
  lang: string = 'en'
): Promise<IOrderResponse> => {
  params['lang'] = lang

  // todo add random delay to test loading state

  return client
    .get(`/order/${carrier}/${id}`, {
      params: params,
      validateStatus: function (status) {
        return status >= 200 && status < 500
      },
    })
    .then(r => r.data)
}

/*
|--------------------------------------------------------------------------
| Utils
|--------------------------------------------------------------------------
*/
export type NecessaryParam = {
  description: string
  name: string
}

/**
 * Merge local package params with the required params from the Carrier
 * This way we make the http request with only the required params
 * @param pkgParams
 * @param carrierNecessaryParams
 */
export const getRequiredParams = (
  pkgParams: { [index: string]: string },
  carrierNecessaryParams: NecessaryParam[]
): { [index: string]: string } => {
  const res = {}

  for (let requiredParam of carrierNecessaryParams) {
    if (pkgParams[requiredParam.name]) {
      res[requiredParam.name] = pkgParams[requiredParam.name]
    }
  }

  return res
}
